import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED } from '../../../constants.tsx';
import type { Props, State } from '../../../types.tsx';
import { maybeWaitForPremiumModal } from '../../utils.tsx';

export const loadStartWithTemplateSpotlightDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		if (typeof getState().startWithTemplateSpotlight.spotlightDismissed === 'boolean') {
			return;
		}

		try {
			const spotlightDismissed = await getUserProperty<boolean>(
				accountId,
				START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED,
			);
			const state = getState();

			setState({
				...state,
				startWithTemplateSpotlight: {
					...state.startWithTemplateSpotlight,
					spotlightDismissed,
				},
			});
		} catch (error) {
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();
				setState({
					...state,
					startWithTemplateSpotlight: {
						...state.startWithTemplateSpotlight,
						spotlightDismissed: false,
					},
				});
				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.start-with-template-spotlight',
				`Failed to get user property with key: ${START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};

export const setStartWithTemplateSpotlightDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();
		setState({
			...state,
			startWithTemplateSpotlight: {
				...state.startWithTemplateSpotlight,
				spotlightDismissed: true,
			},
		});

		try {
			await setUserProperties(accountId, START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.start-with-template-spotlight',
				`Failed to set user property with key: ${START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};
